import crudmaker from '@/store/crudmaker'
import { apiClient } from '@/client'
import merge from 'deepmerge'

const module = 'boardsview'
let doc = {
  list: {
    name: 'Panneaux',
    hasMap: true,
    headers: [
      { label: 'Code', value: 'code' },
      { label: 'Type', value: 'board_type' },
      { label: 'Adresse', value: 'adress', truncate: true },
      { label: 'District', value: 'district', card: false },
      { label: 'Ville', value: 'city', card: false },
      { label: 'Région', value: 'region', card: false },
      { label: 'Localité', value: 'locality', sortable: false, inTable: false, inDetail: false },
      { label: 'Statut', value: 'status' },
    ],
    actions: [
      { icon: 'add', isFlat: false, scope: ['boards.create'], dispatch: `boards/openForm` },
      { icon: 'search', isFlat: true, dispatch: `${module}/openSearch` },
    ],
    dataActions: [
      { icon: 'visibility', dispatch: `boards/goTo` },
      { icon: 'pie_chart', context: {field: 'board_id'}, dispatch: `tenancy/getTenancy` },
    ],
    selectActions: [
      {
        label: 'Supprimer',
        icon: 'delete',
        scope: ['boards.delete'],
        dispatch: `${module}/batchDelete`,
        context: {confirm: true},
        menu: true,
      },
    ],
    search: [
      { label: 'Région', type: 'multilist', name: 'region_id', from: 'name', source: 'regions' },
      { label: 'Ville', type: 'multilist', name: 'city_id', from: 'name', source: 'cities' },
      { label: 'District', type: 'multilist', name: 'district_id', from: 'name', source: 'districts' },
      { label: 'Type', type: 'multilist', name: 'type_id', from: 'name', source: 'boardtypes' },
    ],
  },

  form: {},

  postprocess: item => {
    let locality = `${item.district}, ${item.city}, ${item.region}`
    return {
      position: {lng: parseFloat(item.lon), lat: parseFloat(item.lat)},
      locality,
      ...item,
    }
  },
}

const base = crudmaker(module, apiClient, doc)
const custom = {}
export default merge(base, custom)
